<template>
  <v-row no-gutters>
    <v-snackbar
      v-model="snackState"
      :color="snackColor"
      :timeout="snackTime"
      bottom
      right
    >
      {{ snackText }}
    </v-snackbar>
    <v-col>
      <v-data-table
        :headers="headers"
        :items="logs"
        :search="search"
        :loading="loader"
        loading-text="Listando Datos..."
        class="elevation-1"
      >
        <template v-slot:top>
          <v-layout class="px-3">
            <h2 class="py-4">Listado de Cambios Realizados (Cabina)</h2>
          </v-layout>

          <v-divider></v-divider>
          <v-layout row class="mt-6 mb-4 px-4">
            <v-flex xs12 sm12 md4 class="px-2">
              <v-text-field
                class="text-xs-center"
                v-model="search"
                append-icon="search"
                label="Búsqueda"
                single-line
                hide-details
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm12 md2 class="px-2">
              <v-text-field
                v-model="fechaInicio"
                type="date"
                hide-details
                label="Inicio"
                :max="new Date().toISOString().substr(0, 10)"
                clearable
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm12 md2 class="px-2">
              <v-text-field
                v-model="fechaFin"
                type="date"
                hide-details
                label="Fin"
                :max="new Date().toISOString().substr(0, 10)"
                clearable
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md1 class="text-center pt-3" align-self-center>
              <v-btn
                color="green"
                :block="$vuetify.breakpoint.smAndDown"
                dark
                @click="downloadReporte"
              >
                <v-icon>fas fa-file-excel</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs12 sm12 md1 class="text-center pt-3" align-self-center>
              <v-btn color="blue" dark @click="listar" block> Listar </v-btn>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
        </template>

        <template v-slot:[`item.changedAt`]="{ item }">
          {{ formatDateTime(item.changedAt) }}
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <v-chip v-if="item.action" :color="actionColor(item.action)" dark>
            {{ item.action }}
          </v-chip>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>
  
  <script>
import axios from "axios";
import XLSX from "xlsx";
import moment from "moment";

export default {
  data: () => ({
    snackState: false,
    snackColor: "primary",
    snackTime: 4500,
    snackText: "text",
    fechaInicio: new Date().toISOString().substr(0, 10),
    fechaFin: new Date().toISOString().substr(0, 10),
    loader: false,
    search: "",
    headers: [
      { text: "Número Asistencia", value: "numeroAsistencia", width: 100 },
      { text: "Registro", value: "recordId", align: "center", width: 100 },
      { text: "Campo", value: "fieldName", align: "center", width: 150 },
      {
        text: "Valor Anterior",
        value: "oldValue",
        align: "center",
        width: 400,
      },
      { text: "Valor Nuevo", value: "newValue", align: "center", width: 400 },
      {
        text: "Modificado Por",
        value: "changedBy",
        align: "center",
        width: 150,
      },
      {
        text: "Fecha Modificación",
        value: "changedAt",
        align: "center",
        width: 120,
      },
      // { text: "Tabla", value: "tableName", align: "center", width: 150 },
      { text: "Acción", value: "action", align: "center", width: 75 },
    ],
    logs: [],
    dialog: false,
  }),
  created() {
    this.listar();
  },
  computed: {},
  methods: {
    listar() {
      this.loader = true;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get(
          `api/AuditLog?inicio=${this.fechaInicio}&fin=${this.fechaFin}`,
          configuracion
        )
        .then((res) => (this.logs = res.data))
        .catch((err) => {
          console.error(err);
          if (error.response?.data?.message) {
            this.snackState = true;
            this.snackText = error.response.data.message;
            this.snackColor = "error";
          }
        })
        .finally(() => (this.loader = false));
    },
    formatDateTime(fecha) {
      if (fecha == null) return "- - - -";
      if (!fecha || typeof fecha != "string") {
        throw new Error(
          "El parametro 'fecha' debe ser de tipo String y no puede estar vacio"
        );
      }

      const d = new Date(fecha);

      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      };

      const formattedDate = new Intl.DateTimeFormat("sv-ES", options).format(d);
      return formattedDate;
    },
    actionColor(action) {
      let color = "";
      switch (action) {
        case "MODIFICADO":
          color = "amber darken-2";
          break;
        case "NUEVO":
          color = "green";
          break;
        case "ELIMINADO":
          color = "red";
          break;
        default:
          color = "";
          break;
      }

      return color;
    },
    downloadReporte() {
      const formatDate = (date) => {
        if (!date) return "";
        return moment(date).format("YYYY-MM-DD HH:mm:ss");
      };

      const listadoLogs = this.logs.map((item) => {
        const log = {
          "Número Asistencia": item.numeroAsistencia,
          "Campo Modificado": item.fieldName,
          "Valor Anterior": item.oldValue,
          "Nuevo Valor": item.newValue,
          "Modificado Por": item.changedBy,
          "Fecha Modificación": formatDate(item.changedAt),
        };

        return log;
      });

      let data = XLSX.utils.json_to_sheet(listadoLogs);
      const workbook = XLSX.utils.book_new();
      const filename = `Logs Cabina ${this.fechaInicio} a ${this.fechaFin}`;

      data["!cols"] = [
        { wch: 16 },
        { wch: 25 },
        { wch: 25 },
        { wch: 25 },
        { wch: 30 },
        { wch: 17 },
      ];
      XLSX.utils.book_append_sheet(workbook, data, "Logs");
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
  },
};
</script>